import React, { useContext, useEffect } from 'react';
import { OrganizationContext } from '../../../containers/Context/OrganizationContext';
import HsSelect from '../../Form/HsSelect';
import { strings } from '../../../assets/strings/all';
function GenderSelect(props) {
  const { organization } = useContext(OrganizationContext);
  const { onChange } = props;
  const { visibilityStatuses = [] } = organization || {};
  const { cases } = strings;

  const formattedLabel = (option) => {
    const { name, description } = option;
    return (
      <div className="select-option-wrapper">
        <div className="select-option-name">{name}</div>
        <div className="select-option-description">{description}</div>
      </div>
    );
  };

  useEffect(() => {
    if (props.value && !props.value.name) {
      onChange({ name: props.value });
    }
  }, []);
  return (
    <>
      <HsSelect
        label={cases.gender_only}
        placeholder={cases.gender_only}
        options={[
          {
            label: cases.gender_only,
            options: [
              {
                name: cases.genderList.NA,
                slug: 'NA',
              },
              {
                name: cases.genderList.male,
                slug: 'male',
              },
              {
                name: cases.genderList.female,
                slug: 'female',
              },
            ],
          },
        ]}
        getOptionLabel={(option) => formattedLabel(option)}
        defaultValue={props.value}
        onChange={onChange}
        isClearable={false}
        {...props}
        // value={caseData.visibilityStatus}
      />
    </>
  );
}

export default GenderSelect;
